import {selector, selectorFamily} from 'recoil';
import {ServiceRequestService} from '../../api/services/serviceRequest.service';
import {ReportService} from './../../api/services/report.service';

type TimeStampType = {beginDate: string; endDate: string} | {momentDate: string} | {};

export const reportsQuery = selector({
  key: 'reportsQuery',
  get: async () => {
    const res = await ReportService.getAll();

    return res.data.data;
  },
});

export const reportQueryFamily = selectorFamily({
  key: 'reportsQuery',
  get: (id: string) => async () => {
    const res = await ReportService.getById(id);

    return res.data;
  },
});

export const reportDataQueryFamily = selectorFamily({
  key: 'reportDataQueryFamily',
  get:
    ({id, timeStamp}: {id: string; timeStamp: TimeStampType}) =>
    async () => {
      const res = await ReportService.getReportData(id, timeStamp);

      return res;
    },
});

export const dashboardQuery = selectorFamily({
  key: 'dashboardQuery',
  get: (activeTab: string) => async () => {
    const res = await ReportService.getDashboard({serviceType: activeTab});
    return res.data;
  },
});

export const dashboardPrimaryChartQuery = selectorFamily({
  key: 'dashboardPrimaryChartQuery',
  get:
    ({
      ...params
    }: {
      serviceType?: string;
      status?: string;
      period?: string;
      from?: string;
      to?: string;
      isArchive?: boolean;
    }) =>
    async () => {
      const res = await ReportService.getDashboard(params);
      return res.data;
    },
});

export const dashboardSecondaryChartQuery = selectorFamily({
  key: 'dashboardSecondaryChartQuery',
  get:
    ({
      ...params
    }: {
      serviceType?: string;
      status?: string;
      period?: string;
      from?: string;
      to?: string;
      isArchive?: boolean;
    }) =>
    async () => {
      const res = await ReportService.getDashboard(params);
      return res.data;
    },
});

export const dashboardRequestsQuery = selectorFamily({
  key: 'dashboardRequestsQuery',
  get:
    ({contractIds}: {contractIds: number[]}) =>
    async () => {
      const res = await ServiceRequestService.getServiceRequestsByContractId(contractIds);
      return res.data;
    },
});
